import React from 'react';
import { GroupTypesEnum } from 'types/generated/client';
import BriefCase from 'svg/BriefCase';
import Community from 'svg/Community';
import Key from 'svg/Key';
import Location from 'svg/Location';
import classNames from 'styles/utils/classNames';
import { CommunityBadgeProps } from './types';

const variantIcons: { [key in GroupTypesEnum]: any } = {
  [GroupTypesEnum.College]: Community,
  [GroupTypesEnum.PrivateClub]: Key,
  [GroupTypesEnum.LocalCommunity]: Location,
  [GroupTypesEnum.HighSchool]: BriefCase,
};

export default function CommunityBadge({
  label,
  variant = GroupTypesEnum.College,
  size = 'md',
  className,
  ...rest
}: CommunityBadgeProps) {
  const Icon = variantIcons[variant] || Community;

  return (
    <div
      className={classNames(
        'typography-typography-product-chips-filters flex w-fit flex-1 items-center	 justify-start gap-2 rounded-full',

        !!size && size === 'xs' && 'typography-product-button-label-xs px-2 py-0.5',
        !!size && size === 'sm' && 'typography-product-button-label-small px-2.5 py-1',
        !!size && size === 'md' && 'typography-product-subheading px-3 py-1.5',
        !!size && size === 'lg' && 'typography-product-heading-compact px-8 py-4',

        variant === GroupTypesEnum.LocalCommunity &&
          'bg-green-100 text-green-600 dark:bg-green-100 dark:text-green-600',
        variant === GroupTypesEnum.PrivateClub &&
          'bg-yellow-100 text-yellow-600 dark:bg-yellow-100 dark:text-yellow-600',
        variant === GroupTypesEnum.HighSchool &&
          'bg-blue-100 text-blue-600 dark:bg-blue-100 dark:text-blue-600',
        variant === GroupTypesEnum.College &&
          'bg-color-bg-lightmode-brand-secondary text-color-text-brand dark:bg-color-bg-darkmode-brand-secondary',
      )}
      {...rest}
    >
      <Icon className="h-5 w-5" />
      {label}
    </div>
  );
}
